gsap.registerPlugin(Observer);

import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";

THREE.ColorManagement.enabled = true;

const scene = new THREE.Scene();
scene.background = new THREE.Color(0x1b3344);
scene.fog = new THREE.Fog(0x1b3344, 400, 1000);


// Lights
const dirLight = new THREE.DirectionalLight(0xffffff, 0.75);
dirLight.position.set(0, 400, 200);
dirLight.castShadow = false;
scene.add(dirLight);

const light = new THREE.PointLight(0xffffff, 1, 2000);
light.position.set(0, 200, -50);
light.castShadow = true;
light.shadow.radius = 3;
scene.add(light);

const light2 = new THREE.PointLight(0xffffff, 1, 2000);
light2.position.set(0, 200, 50);
light2.castShadow = true;
light2.shadow.radius = 3;
scene.add(light2);

// Plane
const mesh = new THREE.Mesh(
  new THREE.PlaneGeometry(4000, 4000),
  new THREE.MeshPhongMaterial({ color: 0x1b3344, depthWrite: false })
);
mesh.rotation.x = -Math.PI / 2;
mesh.receiveShadow = true;
scene.add(mesh);

const camera = new THREE.PerspectiveCamera(
  85,
  window.innerWidth / window.innerHeight,
  0.1,
  1000
);
camera.position.set(-294.94477190492963, 150.5236439524381, 117.65245436328895);
// camera.rotation.setFromVector3(
//   new THREE.Vector3(-185.85728413793419, 53.94101435483849, 16.90514969089143),
//   "XYZ"
// );

const renderer = new THREE.WebGLRenderer();
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.shadowMap.enabled = true;
document.body.appendChild(renderer.domElement);

const loader = new GLTFLoader();
loader.load(
  "https://cdn.shopify.com/s/files/1/0675/7249/8706/files/phycocyanin2_2.glb?v=1680672613",
  function (gltf) {
    gltf.scene.traverse(function (child) {
      if (child.isMesh) {
        child.receiveShadow = false;
        child.castShadow = true;
        child.scale.set(100, 100, 100);
      }
    });
    scene.add(gltf.scene);
  },
  (xhr) => {
    console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
  },
  (error) => {
    console.log(error);
  }
);

window.addEventListener("resize", onWindowResize, false);
function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
  render();
}

function animate() {
  requestAnimationFrame(animate);

  camera.updateProjectionMatrix();

  render();
}

function render() {
  renderer.render(scene, camera);
}

animate();

let sections = document.querySelectorAll(".panel"),
  outerWrappers = gsap.utils.toArray(".outer"),
  innerWrappers = gsap.utils.toArray(".inner"),
  currentIndex = -1,
  wrap = gsap.utils.wrap(0, sections.length),
  animating;

gsap.set(innerWrappers, { yPercent: 0 });

function sceneFogTo(near, far) {
  if (near !== null && far !== null) {
    gsap.to(scene.fog, {
      near: near,
      far: far,
      duration: 3,
      ease: "power3.inOut",
    });
  }
}
function cameraTo(position, rotation, fov) {
  if (fov !== null) {
    gsap.to(camera, {
      fov: fov,
      duration: 3,
      ease: "power3.inOut",
    });
  }
  if (position !== null) {
    gsap.to(camera.position, {
      x: position.x,
      y: position.y,
      z: position.z,
      duration: 3,
      ease: "power3.inOut",
    });
  }
  if (rotation !== null) {
    gsap.to(camera.rotation, {
      x: rotation.x,
      y: rotation.y,
      z: rotation.z,
      order: "XYZ",
      duration: 3,
      ease: "power3.inOut",
    });
  }
}

function gotoSection(index, direction) {
  // console.log(index, direction);
  if (
    (index === -1 && direction === -1) ||
    (index === sections.length && direction === 1)
  )
    return;
  animating = true;
  let fromTop = direction === -1,
    dFactor = fromTop ? -1 : 1,
    tl = gsap.timeline({
      defaults: { duration: 1.25, ease: "power1.inOut" },
      onComplete: () => (animating = false),
    });
  if (currentIndex >= 0) {
    gsap.fromTo(
      sections[currentIndex],
      { zIndex: 1, autoAlpha: 1 },
      { zIndex: 0, autoAlpha: 0 }
    );
    tl.fromTo(
      [outerWrappers[currentIndex]],
      {
        yPercent: 0,
        autoAlpha: 1,
      },
      {
        yPercent: (i) => (i ? 30 * dFactor : -30 * dFactor),
        autoAlpha: 0,
      },
      0
    );
  }
  gsap.fromTo(
    sections[index],
    { zIndex: 0, autoAlpha: 0 },
    { zIndex: 1, autoAlpha: 1 }
  );
  tl.fromTo(
    [outerWrappers[index]],
    {
      yPercent: (i) => (i ? -30 * dFactor : 30 * dFactor),
      autoAlpha: 0,
    },
    {
      yPercent: 0,
      autoAlpha: 1,
    },
    0
  );

  if (window.innerWidth < 1024 && (index == 3 || index == 4 || index == 5)) {
    if (index == 3) {
      cameraTo(
        { x: 26, y: 273.8, z: 56.4 },
        {
          x: -64 * (Math.PI / 180),
          y: -22 * (Math.PI / 180),
          z: -37.5 * (Math.PI / 180),
        },
        30
      );
    } else if (index == 4) {
      cameraTo(
        {
          x: 86,
          y: 223.8,
          z: 56.4,
        },
        {
          x: -64 * (Math.PI / 180),
          y: -22 * (Math.PI / 180),
          z: -37.5 * (Math.PI / 180),
        },
        30
      );
      sceneFogTo(400, 1000);
    } else if (index == 5) {
      if (window.innerWidth <= 576) {
        cameraTo(null, null, 85);
      } else {
        cameraTo(null, null, 55);
      }
      cameraTo(
        {
          x: 0,
          y: 900,
          z: 0,
        },
        {
          x: -Math.PI / 2,
          y: 0,
          z: 0,
        },
        null
      );
      sceneFogTo(1000, 1000);
    }
  } else {
    if (index == 0) {
      cameraTo(
        {
          x: -266,
          y: 54,
          z: 17,
        },
        {
          x: -0.5,
          y: -0.285,
          z: -0.15,
        },
        85
      );
    } else if (index == 1) {
      cameraTo(
        {
          x: -228,
          y: 273.8,
          z: 56.4,
        },
        {
          x: -64 * (Math.PI / 180),
          y: -22 * (Math.PI / 180),
          z: -37.5 * (Math.PI / 180),
        },
        35
      );
    } else if (index == 2) {
      cameraTo(
        {
          x: -90,
          y: 288,
          z: 56.4,
        },
        {
          x: -64 * (Math.PI / 180),
          y: -22 * (Math.PI / 180),
          z: -37.5 * (Math.PI / 180),
        },
        35
      );
    } else if (index == 3) {
      cameraTo(
        {
          x: -142,
          y: 298,
          z: 74,
        },
        {
          x: -97 * (Math.PI / 180),
          y: 0,
          z: Math.PI / 2,
        },
        35
      );
    } else if (index == 4) {
      cameraTo(
        {
          x: -26,
          y: 298,
          z: 74,
        },
        {
          x: -97 * (Math.PI / 180),
          y: 0,
          z: Math.PI / 2,
        },
        35
      );
      sceneFogTo(400, 1000);
    } else if (index == 5) {
      cameraTo(
        {
          x: 0,
          y: 800,
          z: 0,
        },
        {
          x: -Math.PI / 2,
          y: 0,
          z: 0,
        },
        35
      );
      sceneFogTo(1000, 1000);
    }
  }
  currentIndex = index;
}

Observer.create({
  type: "wheel,touch,pointer",
  wheelSpeed: -1,
  onDown: () => !animating && gotoSection(currentIndex - 1, -1),
  onUp: () => !animating && gotoSection(currentIndex + 1, 1),
  tolerance: window.innerWidth > 768 ? 1000 : 50,
  preventDefault: true,
});

gotoSection(0, 1);
